import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallWaived({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={8} cy={8} r={8} fill="#999" />
      <path
        d="M5.8 3.8a2.7 2.7 0 00-2.7 2.7v.9a2.7 2.7 0 002.7 2.7h4.707l-1.103 1.104a.7.7 0 00.99.99l2.298-2.299a.7.7 0 000-.99l-2.299-2.298a.7.7 0 10-.99.99L10.506 8.7H5.8a1.3 1.3 0 01-1.3-1.3v-.9a1.3 1.3 0 011.3-1.3h1.56a.7.7 0 100-1.4H5.8z"
        fill="#fff"
      />
    </svg>
  );
}

SvgTickSmallWaived.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallWaived.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickSmallWaived svgRef={ref} {...props} />);
export default ForwardRef;
